module.exports = __webpack_public_path__ + "img/logo_white.a7f583a9.svg";